/**
 * Created by vladislav on 2/20/19
 */

const DailyCupLeadersWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this._super({
            title: Messages.get("DailyCupLeadersWindow.Title"),
            name: "dailycupleaderswindow",
            content: this.createContent()
        });
    },

    getLoadingTasks: function () {
        return [(onSuccess) => {
            if (Cup.DailyCupLeadersCache) {
                onSuccess();
            } else {
                connector.multi.cups.getTop(cleverapps.dailyCup.name, connector.platform.getUserID(), (top) => {
                    if (top) {
                        Cup.DailyCupLeadersCache = top;
                    } else {
                        cleverapps.notification.create(Messages.get("LeadersLoadFailed"));
                    }
                    onSuccess();
                });
            }
        }];
    },

    createContent: function () {
        const data = Cup.DailyCupLeadersCache || {};

        const dataSource = StaticDataSource(() => {
            let results = data.leaders || [], playerFound = false;

            results = results.map((item) => ({
                id: item.id,
                data: {
                    firstPlace: item.firstPlace,
                    secondPlace: item.secondPlace,
                    thirdPlace: item.thirdPlace,
                    avatar: item.avatar,
                    name: item.text
                }
            }));

            for (let i = 0; i < results.length; i++) {
                if (results[i].id === connector.platform.getUserID()) {
                    playerFound = true;
                    results[i].data.player = true;
                    break;
                }
            }
            if (!playerFound) {
                const user = {
                    id: connector.platform.getUserID(),
                    data: {
                        firstPlace: data.playerResult ? data.playerResult.firstPlace : "-",
                        secondPlace: data.playerResult ? data.playerResult.secondPlace : "-",
                        thirdPlace: data.playerResult ? data.playerResult.thirdPlace : "-",
                        player: true,
                        avatar: cleverapps.user.getPlayerInfo().avatar,
                        name: cleverapps.user.getPlayerInfo().name,
                        notInTop: true
                    }
                };
                results.push(user);
            }

            results.forEach((player, index) => {
                player.data.place = index + 1;
            });

            return results;
        });

        const cupsLeadersTable = new ScrollTable(dataSource, { parentView: this });
        const tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !cupsLeadersTable.scrollDisabled,
            mouseScroll: !cupsLeadersTable.scrollDisabled,
            dock: true
        });

        new TableHandler(cupsLeadersTable, tableView, {
            id: "dailyCupLeadersWindow",
            bg: bundles.table.frames.table_bg_png,
            height: cleverapps.styles.DailyCupLeadersWindow.table[cleverapps.resolution.mode].height,
            rowOptions: {
                width: cleverapps.styles.DailyCupLeadersWindow.table[cleverapps.resolution.mode].width,
                prizes: false,
                badges: false
            },
            rowConstructor: DailyCupLeadersRow
        });

        return tableView;
    }
});

cleverapps.styles.DailyCupLeadersWindow = {
    table: [{
        height: 900,
        width: 800
    }, { height: 732 }, { height: 732 }]
};